// plugin setup
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import Vuetify from 'vuetify';
import "vuetify/dist/vuetify.min.css"; //with out this vuetify dosent apply in exsisting project
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import App from './App'

// router setup
import routes from './routes/routes'
import store from './store/store';

// library imports
import Chartist from 'chartist'
import './assets/sass/now-ui-dashboard.scss'
import './assets/css/demo.css'
import 'es6-promise/auto'

// style conditionally for swal modal
function applySwalModalStyle(path) {

  const existing = document.getElementById('custom-swal-style');
  if (existing) existing.remove();

  if (path !== '/' && path !=="/resetPassword") {
    const style = document.createElement('style');
    style.id = 'custom-swal-style';
    style.innerHTML = `
      @media screen and (min-width: 901px) {
        .swal-modal {
          margin-left: 260px !important;
          animation: none !important;
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
}

// Vuetify setup
Vue.use(Vuetify, {
  iconfont: 'mdi'  // ✅ use MDI icons instead of Material Icons font
})
//modules
import payroll from './store/modules/payroll' // Ensure correct path


Vue.use(VueRouter)
Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)
Vue.use(SideBar, { store });

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

const publicPages = ['Login', 'ResetPassword'];

router.beforeEach((to, from, next) => {
  const globalState = JSON.parse(localStorage.getItem("vuex"));
  const isLoggedIn = globalState &&
    globalState.auth &&
    globalState.auth.company &&
    globalState.auth.company.firebase;

  // Allow public pages
  if (publicPages.includes(to.name)) {
    if (to.name === 'Login' && isLoggedIn) {
      return next('/overview');
    }
    return next();
  }

  // If not logged in, redirect to login
  if (!isLoggedIn) {
    return next('/');
  }

  next();
});

// 🔁 Apply modal style based on route
router.afterEach((to) => {
  applySwalModalStyle(to.path)
})

// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
  get() {
    return this.$root.Chartist
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  data: {
    Chartist: Chartist
  },
  modules: {
    payroll,
  },
})


// WEBPACK FOOTER //
// ./src/main.js